<template>
    <div class="sms-enter" v-if="store.needSms">
        <div class="content">
            <div class="top">
                <div class="title">Введите код, отправленный в СМС</div>
                <a class="close" @click="store.closeCode()">&times;</a>
            </div>
            <div class="enter">
                <div class="code">
                    <vue-numeric
                            :key="index"
                            :minus="false"
                            :max="9"
                            :readonly="isSend"
                            :ref="'code'+index"
                            placeholder="X"
                            maxlength="1"
                            separator=""
                            thousand-separator=""
                            v-model="code[index]"
                            v-for="(index) in [0,1,2,3]"
                            @input="nextInput(index)"
                    ></vue-numeric>
                </div>
            </div>
            <div class="bottom" v-if="isSend || error !== null">
                <div class="loader" v-if="isSend">
                    <img src="../../../../assets/loader.svg">
                    <div class="text">
                        Идет отправка данных
                    </div>
                </div>
                <div class="error" v-if="error !== null">
                    {{error}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueNumeric from 'vue-numeric';
    export default {
        props: ["store"],
        components: {
            VueNumeric
        },
        methods: {
            nextInput(index){
                if (index < 3){
                    const next = 'code' + (index + 1);
                    if (typeof this.$refs[next][0] != "undefined"){
                        this.code[index + 1] = 0;
                        this.$refs[next][0].$el.focus();
                    }
                }else{
                    this.isSend = true;
                    this.error = null;
                    this.store.createOrder(this.code.join('')).then((response) => {
                        if (response.code >= 200 && response.code < 300){
                            this.store.closeCode();
                            this.store.openMessage(response.data.message, 'success');
                            if (response.code == 201){
                                if (typeof yacurierCallAfterOrder == "function") {
                                    yacurierCallAfterOrder();
                                }
                               this.store.init();
                            }
                        }
                    }).catch((error) => {
                        this.isSend = false;
                        this.error = typeof error.response.data.data.message != "undefined" ? error.response.data.data.message : error;
                    });
                }
            }
        },
        data(){
            return {
                isSend: false,
                error: null,
                code: []
            }
        }
    }
</script>

<style lang="scss">
    #yacurier-form{
        .full-form{
            .sms-enter{
                align-items: center;
                background: rgba(0,0,0,.5);
                bottom: 0;
                display: flex;
                justify-content: center;
                left: 0;
                position: fixed;
                right: 0;
                top: 0;
                z-index: 1001;
                .content{
                    background: #FFF;
                    border: 1px solid #f2f6fc;
                    box-shadow: 0 0 20px 0 rgba(164, 182, 206, .5);
                    max-width: 500px;
                    position: relative;
                    .top{
                        align-items: center;
                        background: #FBFCFB;
                        border-bottom: 1px solid #D0D5E0;
                        display: flex;
                        padding: 10px 20px;
                        .title{
                            flex-grow: 1;
                            flex-shrink: 0;
                            font-size: 14px;
                            font-weight: bold;
                        }
                        .close{
                            background: none;
                            border: none;
                            color: #333;
                            cursor: pointer;
                            flex-grow: 0;
                            flex-shrink: 1;
                            font-size: 20px;
                            margin-left: 20px;
                            opacity: .45;
                            &:hover{
                                opacity: 1;
                            }
                        }
                    }
                    .enter{
                        padding: 20px;
                        .code{
                            display: flex;
                            justify-content: space-between;
                            margin-left: -10px;
                            margin-right: -10px;
                            input{
                                box-sizing: border-box;
                                border-radius: 8px;
                                font-size: 30px;
                                height: 100px;
                                margin-left: 10px;
                                margin-right: 10px;
                                text-align: center;
                                width: calc(25% - 20px);
                            }
                        }
                    }
                    .bottom{
                        background: #FBFCFB;
                        border-top: 1px solid #D0D5E0;
                        padding: 10px 20px;
                        .loader{
                            align-items: center;
                            display: flex;
                            justify-content: flex-start;
                            img{
                                margin-right: 20px;
                                width: 32px;
                            }
                            .text{
                                font-size: 12px;
                            }
                        }
                        .error{
                            color: #E66256;
                            font-size: 12px;
                        }
                    }

                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/blocks/FullForm/components/Sms.vue